import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Input, Select } from 'antd';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Controller } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'antd/lib/radio';

import GetField from '../Components/GetField';
import styles from '../styles';
import ShowFiles from './ShowFiles';
import { deleteQualityCheckItem } from '../Actions';

const AntSelect = GetField(Select);
const AntInput = GetField(Input);
const { Option } = Select;

const ItemForm = props => {
  const {
    classes,
    getValues,
    setValue,
    control,
    watch,
    itemItem,
    itemIndex,
    itemRemove,
    itemAppend,
    unregister,
  } = props;

  const dispatch = useDispatch();

  const [FileModal, SetFileModal] = useState(false);

  const itemsTable = useSelector(
    state => state.inwardItemsForQualityCheckInputTable.items
  );

  const shadeArray = useMemo(() => {
    if (itemsTable.names.length) {
      const name = getValues(`items[${itemIndex}].name`);

      if (itemsTable.shades[name] !== undefined) {
        return itemsTable.shades[name] || [];
      }
    }
    return [];
  }, [itemsTable, watch(`items[${itemIndex}].name`)]);

  const sizeArray = useMemo(() => {
    if (itemsTable.names.length) {
      const name = getValues(`items[${itemIndex}].name`);
      const shade = getValues(`items[${itemIndex}].shade`);

      if (itemsTable.sizes?.[name]?.[shade] !== undefined) {
        return itemsTable.sizes[name][shade] || [];
      }
    }
    return [];
  }, [
    itemsTable,
    watch(`items[${itemIndex}].name`),
    watch(`items[${itemIndex}].shade`),
  ]);

  const unitArray = useMemo(() => {
    if (itemsTable.names.length) {
      const name = getValues(`items[${itemIndex}].name`);
      const shade = getValues(`items[${itemIndex}].shade`);
      const size = getValues(`items[${itemIndex}].size`);

      if (itemsTable.units?.[name]?.[shade]?.[size] !== undefined) {
        return itemsTable.units[name][shade][size] || [];
      }
    }
    return [];
  }, [
    itemsTable,
    watch(`items[${itemIndex}].name`),
    watch(`items[${itemIndex}].shade`),
    watch(`items[${itemIndex}].size`),
  ]);

  return (
    <>
      <tr>
        <td className={classes.inputTd}>
          <Controller
            name={`items[${itemIndex}].name`}
            control={control}
            defaultValue={itemItem.name}
            render={({ field }) => (
              <AntSelect placeholder="Select item" {...field}>
                {itemsTable.names.map(item => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`items[${itemIndex}].shade`}
            control={control}
            defaultValue={itemItem.shade}
            render={({ field }) => (
              <AntSelect placeholder="Select shade" {...field}>
                {shadeArray.map(shade => (
                  <Option key={shade} value={shade}>
                    {shade}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`items[${itemIndex}].size`}
            control={control}
            defaultValue={itemItem.size}
            render={({ field }) => (
              <AntSelect placeholder="Select size" {...field}>
                {sizeArray.map(size => (
                  <Option key={size} value={size}>
                    {size}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`items[${itemIndex}].unitId`}
            control={control}
            defaultValue={itemItem.unitId}
            render={({ field }) => (
              <AntSelect placeholder="Select unit" {...field}>
                {unitArray.map(({ unit, id }) => (
                  <Option key={id} value={id}>
                    {unit}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`items[${itemIndex}].quantity`}
            control={control}
            defaultValue={itemItem.quantity}
            render={({ field }) => (
              <AntInput
                {...field}
                placeholder="Quantity"
                type="number"
                min={0}
                size="small"
              />
            )}
          />
        </td>
        <td
          className={classes.inputTd}
          style={{
            textAlign: 'center',
          }}
        >
          <Controller
            name={`items[${itemIndex}].condition`}
            control={control}
            defaultValue={itemItem.condition}
            render={({ field }) => (
              <AntSelect placeholder="Select condition" {...field}>
                <Option key="rejected" value="rejected">
                  Rejected
                </Option>
                <Option key="accepted" value="accepted">
                  Accepted
                </Option>
                <Option key="altered" value="altered">
                  Altered
                </Option>
              </AntSelect>
            )}
          />
        </td>
        <td className={classes.inputTd}>
          <Controller
            name={`items[${itemIndex}].remark`}
            control={control}
            defaultValue={itemItem.remark}
            render={({ field }) => <AntInput placeholder="Remark" {...field} />}
          />
        </td>
        <td className={classes.inputTd}>
          <Button onClick={() => SetFileModal(true)}>File</Button>
        </td>
        <td className={classes.inputTd}>
          <DeleteOutlined
            onClick={() => {
              const items = getValues('items');
              if (items && items.length > 1) {
                itemRemove(itemIndex);
                dispatch(deleteQualityCheckItem('items', itemIndex));
              }
            }}
          />
          &nbsp; &nbsp;
          <PlusCircleOutlined
            onClick={() =>
              itemAppend({
                name: null,
                shade: null,
                size: null,
              })
            }
          />
        </td>
      </tr>
      {FileModal ? (
        <ShowFiles
          itemIndex={itemIndex}
          itemType="items"
          watch={watch}
          setValue={setValue}
          unregister={unregister}
          SetFileModal={SetFileModal}
        />
      ) : null}
    </>
  );
};

ItemForm.propTypes = {
  classes: PropTypes.object.isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  watch: PropTypes.func.isRequired,
  itemAppend: PropTypes.func.isRequired,
  itemRemove: PropTypes.func.isRequired,
  itemItem: PropTypes.object.isRequired,
  itemIndex: PropTypes.number.isRequired,
  unregister: PropTypes.func.isRequired,
};

export default withStyles(styles)(ItemForm);
